import {remCalc} from '_themeUtils'

const accordion = {
    Accordion: {
        baseStyle: {
            root: {},
            container: {
                borderColor: 'color.border.accordion.default',
            },
            button: {
                textStyle: 'paragraphMd',
                letterSpacing: remCalc(0.6),
                color: 'color.text.accordion.default',
                fontWeight: 400,
                background: 'color.background.accordion.default',
                py: 'spacing.6',
                px: 0,
                div: {
                    flex: 1,
                    textAlign: 'left',
                },
                svg: {
                    transition: 'all .2s ease-in-out',
                },
                _hover: {
                    color: 'color.text.accordion.hover',
                    background: 'color.background.accordion.hover',
                },
                _expanded: {
                    svg: {
                        transform: 'rotate(180deg)',
                    },
                },
                // Fix outline offset
                _focus: {
                    outlineOffset: `${remCalc(-1)} !important`,
                },
            },
            panel: {
                pb: 'spacing.4',
            },
            icon: {},
        },
        variants: {
            footer: {
                button: {
                    px: 'spacing.5',
                    _expanded: {
                        borderBottom: `${remCalc(1)} solid`,
                        borderBottomColor: 'color.border.accordion.default',
                        svg: {
                            transform: 'none',
                        },
                    },
                },
                panel: {
                    px: 'spacing.5',
                },
            },
        },
    },
}

export default accordion
